
const turkeyHotels = {
  49554: true,
  48733: true,
  47958: true,
  101316: true,
  48779: true,
  49513: true,
  47435: true,
  48107: true,
  49245: true,
  47495: true,
  48687: true,
  49271: true,
  49614: true,
  48176: true,
  48860: true,
  85639: true,
  47551: true,
  48525: true,
  49100: true,
  143449: true,
  48722: true,
  49369: true,
  49127: true,
  139083: true,
  49629: true,
  281805: true,
  48226: true,
  48228: true,
  48554: true,
  47474: true,
  47936: true,
  48669: true,
  48159: true,
  48988: true,
  132367: true,
  274914: true,
  48392: true,
  48743: true,
  48931: true,
  47508: true,
  49216: true,
  49507: true,
  274865: true,
  130318: true,
  47560: true,
  47950: true,
  49155: true,
  48745: true,
  48681: true,
  49542: true,
  47987: true,
  49312: true,
  100815: true,
  47531: true,
  48257: true,
  48592: true,
  98838: true,
  129528: true,
  142722: true,
  180202: true,
  48361: true,
  98670: true,
  47785: true,
  116358: true,
  49248: true,
  105636: true,
  129815: true,
  47866: true,
  48401: true,
  49304: true,
  334563: true,
  100570: true,
  105683: true,
  47595: true,
  345860: true,
  48297: true,
  49213: true,
  47580: true,
  47937: true,
  48996: true,
  49187: true,
  49432: true,
  49588: true,
  98480: true,
  48294: true,
  48762: true,
  129605: true,
  47385: true,
  48217: true,
  48682: true,
  47992: true,
  48152: true,
  49006: true,
  91358: true,
  47415: true,
  104259: true,
  48856: true,
  47414: true,
  49069: true,
  47971: true,
  48346: true,
  49008: true,
  48112: true,
  100961: true,
  347690: true,
  47911: true,
  49110: true,
  316345: true,
  47872: true,
  49598: true,
  105110: true,
  97275: true,
  97523: true,
  47481: true,
  47521: true,
  47701: true,
  48390: true,
  139897: true,
  47917: true,
  49407: true,
  168851: true,
  48173: true,
  48461: true,
  48847: true,
  100573: true,
  138032: true,
  47529: true,
  47784: true,
  47825: true,
  49347: true,
  133391: true,
  107256: true,
  129767: true,
  275537: true,
  47429: true,
  47656: true,
  48042: true,
  48588: true,
  48639: true,
  116550: true,
  47380: true,
  47450: true,
  97096: true,
  48327: true,
  47446: true,
  49288: true,
  47388: true,
  47693: true,
  47903: true,
  48832: true,
  48899: true,
  49239: true,
  116542: true,
  47947: true,
  48044: true,
  48259: true,
  48242: true,
  48330: true,
  49197: true,
  48505: true,
  49114: true,
  49131: true,
  49163: true,
  49076: true,
  137678: true,
  140361: true,
  276823: true,
  49372: true,
  277230: true,
  49566: true,
  49551: true,
  49580: true,
  97733: true,
  49606: true,
  105648: true,
  111924: true,
  129570: true,
  48158: true,
  47721: true,
  47921: true,
  47998: true,
  48440: true,
  48691: true,
  48151: true,
  48721: true,
  97570: true,
  47513: true,
  48541: true,
  48775: true,
  48785: true,
  49068: true,
  49115: true,
  49140: true,
  49306: true,
  105541: true,
  316312: true,
  47572: true,
  47905: true,
  48443: true,
  49139: true,
  49630: true,
  47681: true,
  48238: true,
  48432: true,
  49316: true,
  49371: true,
  117198: true,
  129227: true,
  274738: true,
  47534: true,
  47678: true,
  47889: true,
  48398: true,
  48479: true,
  48895: true,
  48994: true,
  49223: true,
  49387: true,
  49401: true,
  98387: true,
  98408: true,
  105520: true,
  119680: true,
  316344: true,
  333427: true,
  47477: true,
  47570: true,
  47583: true,
  47591: true,
  47667: true,
  47902: true,
  47948: true,
  48282: true,
  48436: true,
  48499: true,
  48506: true,
  48509: true,
  48559: true,
  48615: true,
  48623: true,
  48630: true,
  48640: true,
  48920: true,
  48952: true,
  48964: true,
  49030: true,
  49191: true,
  49279: true,
  49320: true,
  49389: true,
  49440: true,
  49621: true,
  87873: true,
  101278: true,
  104601: true,
  107621: true,
  128244: true,
  140640: true,
  143039: true,
  144011: true,
  144037: true,
  278667: true,
  333412: true,
  47674: true,
  47755: true,
  47382: true,
  47391: true,
  47896: true,
  48799: true,
  48051: true,
  129407: true,
  317518: true,
  135783: true,
  47779: true,
  48657: true,
  47898: true,
  105139: true,
  105556: true,
  47991: true,
  47427: true,
  48045: true,
  49073: true,
  308790: true,
  319310: true,
  48430: true,
  47930: true,
  49286: true,
  47941: true,
  48370: true,
  48624: true,
  48914: true,
  48586: true,
  48987: true,
  48882: true,
  107681: true,
  49453: true,
  48936: true,
  49019: true,
  49359: true,
  47480: true,
  324922: true,
  47574: true,
  49637: true,
  275356: true,
  131779: true,
  47625: true,
  49077: true,
  142439: true,
  278758: true,
  47624: true,
  48804: true,
  49538: true,
  47554: true,
  47582: true,
  47831: true,
  47868: true,
  47906: true,
  47962: true,
  48695: true,
  49410: true,
  49649: true,
  104595: true,
  105524: true,
  138037: true,
  47479: true,
  47675: true,
  47990: true,
  48533: true,
  48552: true,
  48603: true,
  48735: true,
  48737: true,
  48810: true,
  48829: true,
  49108: true,
  49589: true,
  98479: true,
  101218: true,
  116317: true,
  122876: true,
  131019: true,
  133806: true,
  138993: true,
  336653: true,
  47753: true,
  48019: true,
  49466: true,
  127407: true,
  47519: true,
  48637: true,
  49429: true,
  48214: true,
  48288: true,
  48384: true,
  48780: true,
  48992: true,
  49149: true,
  104762: true,
  288135: true,
  47691: true,
  47757: true,
  47848: true,
  47973: true,
  48043: true,
  48298: true,
  48516: true,
  48542: true,
  48625: true,
  48661: true,
  48715: true,
  48761: true,
  49156: true,
  49185: true,
  49350: true,
  49396: true,
  49506: true,
  100696: true,
  105133: true,
  105590: true,
  116541: true,
  120357: true,
  127402: true,
  131437: true,
  140751: true,
  266585: true,
  284322: true,
  47522: true,
  48400: true,
  49378: true,
  49493: true,
  97537: true,
  101237: true,
  106764: true,
  116543: true,
  135391: true,
  135432: true,
  138285: true,
  140765: true,
  140811: true,
  142402: true,
  142942: true,
  164221: true,
  214533: true,
  275072: true,
  276775: true,
  284787: true,
  306401: true,
  104267: true,
  330848: true,
  49151: true,
  319299: true,
  129774: true,
  316325: true,
  100760: true,
  48216: true,
  49469: true,
  332456: true,
  47974: true,
  47969: true,
  49509: true,
  48438: true,
  104268: true,
  342003: true,
  104599: true,
  136187: true,
  48375: true,
  291815: true,
  275538: true,
  132502: true,
  294382: true,
  119715: true,
  179537: true,
  194293: true,
  291873: true,
  134603: true,
  100888: true,
  101479: true,
  100956: true,
  48548: true,
  282411: true,
  274939: true,
  105107: true,
  117311: true,
  48364: true,
  47925: true,
  289269: true,
  334853: true,
  347527: true,
};

export default {
  ...turkeyHotels,
};
